import { DataSource, Layout } from "@mcleod/components";
import { LtlStop } from "../LtlStop";

export abstract class AutogenLayoutLtlQuoteStopDetails extends Layout {
    layoutStopTable: LtlStop;
    sourceQuoteStops: DataSource;
}
